export default [
  {
    key: "name",
    label: "field.name",
    type: "text",
  },
  {
    key: "email",
    label: "field.email",
    type: "text",
  },
  {
    key: "isActive",
    label: "field.status",
    type: "radio",
    options: [
      { text: "status.invited", value: "2" },
      { text: "status.active", value: "1" },
      { text: "status.inactive", value: "0" },
    ],
    md: "auto",
    lg: "auto",
  },
];
